module.exports = __webpack_public_path__ + "img/Settings.47c97ba1.svg";